import { Checkbox, Col, Divider, Form, notification, Row } from 'antd';
import { memo, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

import ButtonWrap from '@/components/ButtonWrap';
import FormItemWrap from '@/components/FormItemWrap';
import InputOnlyNumber from '@/components/InputOnlyNumber';
import InputWrap from '@/components/InputWrap';
import { pattern } from '@/constants/validate';
import { appRoutes } from '@/router/routes';
import categoryService from '@/services/category.service';
import { handleMessageError } from '@/util/handleMessageError';

import './style.scss';
import { CategoryForm } from '@/dto/responseDto/category';

const FormData = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm<CategoryForm>();

    const { data: category } = useQuery([id], () => categoryService.findById(id), {
        enabled: !!id,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { mutate: mutateCreate } = useMutation((body: CategoryForm) => categoryService.create(body), {
        onSuccess: () => {
            onGoList();
            notification.success({
                message: 'THÊM DANH MỤC THÀNH CÔNG',
            });
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const { mutate: mutateUpdate } = useMutation([], (body: CategoryForm) => categoryService.update(id, body), {
        onSuccess: () => {
            onGoList();
            notification.success({
                message: 'CẬP NHẬT THÀNH CÔNG',
            });
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const onGoList = () => {
        reset({});
        navigate(`${appRoutes.ADMIN.SERVICE.ROOT}`);
    };

    const onSubmit = (data: CategoryForm) => {
        if (id) {
            mutateUpdate(data);
        } else {
            mutateCreate(data);
        }
    };

    const BtnOptions = () => {
        if (!id) {
            return (
                <>
                    <Col span={6}>
                        <ButtonWrap htmlType="submit" text={`THÊM`} type="primary" width="100%" />
                    </Col>
                </>
            );
        } else {
            return (
                <>
                    <Col span={6}>
                        <ButtonWrap htmlType="submit" text={`CẬP NHẬT`} type="primary" width="100%" />
                    </Col>
                </>
            );
        }
    };

    useEffect(() => {
        if (category) {
            reset({
                id: category?.data?._id,
                name: category?.data?.name,
                sortOrder: category?.data?.sortOrder,
            });
        } else {
            reset({ id: undefined, name: undefined, sortOrder: undefined });
        }
    }, [category, reset]);

    return (
        <div className="p-add-category__form">
            <Form labelCol={{ span: 6, md: { span: 8 }, lg: { span: 6 } }} onFinish={handleSubmit(onSubmit)}>
                <Row>
                    <Col span={24} xl={{ span: 16, offset: 4 }} xxl={{ span: 12, offset: 6 }}>
                        <FormItemWrap
                            labelAlign="right"
                            label="Danh mục"
                            required
                            colon={false}
                            validateStatus={errors?.name ? 'error' : ''}
                        >
                            <Controller
                                name="name"
                                control={control}
                                rules={{
                                    required: true,
                                    maxLength: 30,
                                }}
                                render={({ field }) => <InputWrap field={field} />}
                            />
                        </FormItemWrap>

                        <FormItemWrap
                            labelAlign="right"
                            label="Sắp xếp"
                            required
                            colon={false}
                            validateStatus={errors?.sortOrder ? 'error' : ''}
                        >
                            <Controller
                                name="sortOrder"
                                control={control}
                                rules={{
                                    required: true,
                                    maxLength: 3,
                                    pattern: pattern.inputNumber,
                                }}
                                render={({ field }) => <InputOnlyNumber maxLength={3} field={field} />}
                            />
                        </FormItemWrap>

                        <Row justify="end" gutter={16}>
                            <BtnOptions />
                        </Row>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default memo(FormData);
